module.exports = __webpack_public_path__ + "static/media/fbe-icon-green.f0684a73.svg";